module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"pvModules":"Anzahl PV-Module","pvCapacity":"PV-Leistung","pvProduction":"Spezifischer Stromertrag","pvCoverage":"Belegung","pvCoverageFull":"Vollständige Nutzung","pvCoveragePartial":"Teilweise Nutzung"}}')
  delete Component.options._Ctor
}
